import React from 'react';
import '../styles/forms.css';
import { TextField } from 'react-md';
import { Button as BtnReact} from 'reactstrap';

export default class FrmLogin extends React.Component {
  constructor(props) {
    super(props);
    this.enterPass = this.enterPass.bind(this);
    this.clickOlvidar = this.clickOlvidar.bind(this);
    this.clickCrear= this.clickCrear.bind(this);
  }

  clickOlvidar(){
   
   
    var btn = document.getElementById('Id_olvidada');
    btn.click();
  }
  clickCrear(){
    var txtidSolicit=document.getElementById("Id_Vacante");
    var txtidZonific=document.getElementById("Id_Zonificacion");
    if(txtidSolicit && txtidZonific ){
      var data='{"idSolicitud":"'+txtidSolicit.innerText+'", "idZonificacion":"'+txtidZonific.innerText+'"}'
      localStorage.setItem('post',data)
    }
    var btn = document.getElementById('Id_Registrarse');
       
    if(btn)
    btn.click();
  }
  enterPass(e){
    if(e.key === 'Enter'){
      var btn=document.getElementById('Frm_btn_Lgn');
      if(btn)
      btn.click();
    }
  }

  render() {
    return (
      <div className="ARC_Lgn_dv">
        <TextField id="IdUsuario" label="Correo electrónico" lineDirection="center" className="lg-cell lg-cell--bottom" />
        <TextField id="IdPass" label="Contraseña" type="password" className="lg-cell lg-cell--bottom" onKeyUp={(e)=> this.enterPass(e)}/>
        {/* <BtnReact color='secondary' className='btn_no_decor' onClick={(e)=> this.clickCrear(e)}>Crear Cuenta</BtnReact><br/> */}
        <BtnReact color='secondary' className='btn_no_decor' onClick={(e)=> this.clickOlvidar(e)}>¿Olvidaste tu contraseña?</BtnReact><br/>
      </div>
    );
  }
}